<template>
  <b-popover
    :target="target"
    :disabled="disabled"
    :placement="placement"
    :triggers="triggers"
    @show="cloneSubRequests"
  >
    <div class="vt-print-label-popover ap-popover">
      <custom-modal-header>
        {{ $t('component.studyRequest.popover.printLabelPopover.printAllLabels') }}
      </custom-modal-header>

      <div class="vt-print-label-popover__body">
        <p class="mb-2">
          <strong class="vt-print-label-popover__list-title filter-label mb-2">
            {{ $t('component.studyRequest.popover.printLabelPopover.selectLabelToPrint') }}:
          </strong>
        </p>

        <div class="vt-print-label-popover__all-toggle d-flex justify-content-end">
          <b-form-checkbox
            v-model="allSelected"
            class="u-form-checkbox-input-to-end mb-1 filter-label"
            @change="toggleAll"
          >
            {{ $t('component.studyRequest.popover.printLabelPopover.all') }}
          </b-form-checkbox>
        </div>

        <div
          v-if="elements"
          class="vt-print-label-popover__list thin-scroll"
        >
          <div
            v-for="(item, index) in items"
            :key="index"
            class="vt-print-label-popover__list-item d-flex justify-content-between"
          >
            <div>
              <b-form-select
                v-model="item.copies"
                :options="quantityOptions"
                class="format-select"
              />
            </div>
            <div class="filter-label">
              {{ $t('component.studyRequest.popover.printLabelPopover.label') }} {{ item.surExternalId }}
            </div>
            <div>
              <b-form-checkbox
                :id="index | abc"
                v-model="item.selectedForPrint"
              />
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end">
          <b-btn
            variant="link"
            class="vt-print-label-popover__footer-btn"
            @click="printLabels"
          >
            {{ $t('component.studyRequest.popover.printLabelPopover.printSelectedLabels') }}
          </b-btn>
        </div>
      </div>
    </div>
  </b-popover>
</template>

<script>

import CustomModalHeader from './CustomModalHeader'
import { cloneDeep } from 'lodash'

export default {
    name: 'PrintLabelPopover',
    components: {
        CustomModalHeader
    },
    props: {
        target: { type: String, required: true },
        labId: { type: Number },
        parentId: { type: Number },
        elements: { type: Array },
        labelField: { type: String },
        disabled: { type: Boolean, default: false },
        placement: { type: String, default: 'bottom' },
        triggers: { type: String, default: 'focus' }
    },
    data() {
        return {
            items: [],
            quantityOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
        }
    },
    computed: {
        allSelected: {
            get() {
                return this.items.filter(i => i.selectedForPrint === true).length === this.items.length
            },
            set() {
                // do nothing. changes are applied on the toggleAll method
            }
        }
    },
    methods: {
        cloneSubRequests() {
            this.items = cloneDeep(this.elements)
            this.items.forEach(i => {
                i.copies = 1
            })
        },
        toggleAll(value) {
            this.items.forEach(i => {
                i.selectedForPrint = value
            })
            this.$forceUpdate()
        },
        async printLabels() {
            const itemsToPrint = this.items.filter(i => i.selectedForPrint === true)
            this.$emit('printSelectedLabelsWithCopies', itemsToPrint)
        }
    }
}

</script>

<style lang="scss">

  .u-form-checkbox-input-to-end {
    padding-right: 1.5rem;
    padding-right: 24px;
    padding-left: 0;

    .custom-control-label {
      display: flex;

      &::before,
      &::after {
        right: -1, 5rem;
        right: -24px;
        left: unset;
      }
    }
  }

</style>

<style lang="scss" scoped>

  .vt-print-label-popover {
    color: vt-color(gray);
  }

  .vt-print-label-popover__body {
    padding: {
      right: 10px;
      left: 10px;
    }
  }

  .vt-print-label-popover__list-title {
    font-size: 11px;
  }

  .vt-print-label-popover__all-toggle {
    margin-right: 7px;
  }

  .vt-print-label-popover__list {
    max-height: 165px;
    overflow-y: auto;
    overflow-x: hidden;
    margin-left: -3px;

      ::v-deep .format-select {
      font-family: "Roboto", sans-serif;
      font-size: font-size(normal);
      width: auto;
    }
  }

  .vt-print-label-popover__list-item {
    margin-bottom: 5px;
    padding: {
      top: 3px;
      left: 3px;
    }
  }

  .vt-print-label-popover__footer-btn {
    font-size: font-size(tiny);
  }

</style>

<style lang="scss">
  .vt-print-label-popover {

    .custom-control-input {
      display: none;
    }

    .popover-body {
      padding: 0;
    }
  }
</style>
